import i18nFactory, { i18nRaw as i18nRawFactory } from '@yandex-int/i18n';
import { get } from 'lodash';
import { Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

import { Action } from '../../actions';
import {
    ADD_CALLOUTS,
    AddCallouts,
    addCalloutsSuccess,
    deleteCalloutsSuccess,
    REMOVE_CALLOUTS,
    RemoveCallouts,
    showAddCalloutsError
} from '../../actions/banners-edit/callouts';
import { removeCalloutsIdsFromBanners } from '../../actions/bannersEdit';
import { confirm } from '../../service/Confirm/Confirm';
import { EpicDeps } from '../../service/StoreFactory';
import { Callout } from '../../typings/banners';
import { GdCalloutStatusModerate, SaveCallouts } from '../../typings/graphql-grid';
import { State } from '../../typings/state';

import * as keyset from './callouts.i18n';

const i18n = i18nFactory(keyset);
const i18nRaw = i18nRawFactory(keyset);

const AddCalloutsEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) =>
    action$.pipe(
        ofType(ADD_CALLOUTS),
        mergeMap(
            (action: AddCallouts): Observable<Action> => {
                return from(
                    deps.calloutsMutation.addCallouts({
                        saveItems: action.newCallouts.map(text => {
                            return { text };
                        })
                    })
                ).pipe(
                    mergeMap(
                        (result: SaveCallouts): Observable<Action> => {
                            const calloutIds = get(result, 'saveCallouts.calloutIds', []);
                            const callouts: Callout[] = calloutIds.map((id: string, index: number) => {
                                return {
                                    id: String(id),
                                    text: action.newCallouts[index],
                                    statusModerate: GdCalloutStatusModerate.READY
                                };
                            });

                            return of(addCalloutsSuccess(action.bannerId, callouts));
                        }
                    ),
                    catchError(
                        (error): Observable<Action> => {
                            return of(showAddCalloutsError(action.bannerId, error));
                        }
                    )
                );
            }
        )
    );

const RemoveCalloutsEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) =>
    action$.pipe(
        ofType(REMOVE_CALLOUTS),
        mergeMap(
            (action: RemoveCallouts): Observable<Action> => {
                return from(
                    confirm({
                        message: i18n('title'),
                        children: i18nRaw('confirm')
                    })
                ).pipe(
                    mergeMap(
                        (): Observable<Action> => {
                            return from(
                                deps.calloutsMutation.deleteCallouts({
                                    calloutIds: action.calloutIds.map((id: string) => id),
                                    detachBeforeDelete: true
                                })
                            ).pipe(
                                switchMap(
                                    (): Array<Action> => [
                                        deleteCalloutsSuccess(action.bannerId, action.calloutIds),
                                        removeCalloutsIdsFromBanners(action.calloutIds)
                                    ]
                                ),
                                catchError(
                                    (error): Observable<Action> => {
                                        return of(showAddCalloutsError(action.bannerId, error));
                                    }
                                )
                            );
                        }
                    ),
                    catchError((): Observable<Action> => of(deleteCalloutsSuccess(action.bannerId, [])))
                );
            }
        )
    );

export { AddCalloutsEpic, RemoveCalloutsEpic };
